/** =========================================================
 * Emails controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-emails')
    .controller('EmailsController', EmailsController);

  EmailsController.$inject = [
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    'ngDialog'
  ];

  function EmailsController(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    ngDialog
  ) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      vm.tableConfig = {
        model: 'email',
        getDataParams: {
          order: {
            id: 'desc'
          }
        },
        filters: angular.copy($stateParams.filters),
        fields: [{
          title: 'Date',
          key: 'date',
          minWidth: '140px',
          customType: 'dateTime',
          order: true
        }, {
          title: 'To',
          key: 'to',
          order: true
        }, {
          title: 'Subject',
          key: 'subject',
          order: true
        }],
        customButtons: [{
          permission: $rootScope.helpers.hasPermissionTo('email view'),
          title: 'Content',
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.item = item;

              ngDialog.openConfirm({
                template: 'app/views/dialogs/email.html',
                className: 'ngdialog-theme-default ngdialog-wide',
                scope: dialogScope
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          icon: 'icon-menu',
          class: 'btn-default'
        }],
        topButtons: [{
          title: 'Update',
          permission: $rootScope.helpers.hasPermissionTo('email view'),
          action: function () {
            try {
              vm.tableConfig.getData();
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: 'Update'
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
